import { Box } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid-pro'
import { useTranslation } from 'react-i18next'
import { Delete } from '@mui/icons-material'
import { useDialogCtx } from 'src/hooks/context-hooks'
import { useDeleteLocality } from '../../../api/locality-groups-locality-links'
import { invalidateLocalityGroupsQueries, useGetLocalitiesInLocalityGroups } from '../../../api/locality-groups'
import { useCustomerCtx } from '../../../hooks/context-hooks'
import { CustomStyledTable } from 'src/screens/localities/moorings/Components/PositionTable'
import { toast } from 'react-toastify'

const LocalitiesInLocalityGroups = ({ localityGroupId }) => {
  const { t } = useTranslation(['access-control', 'common', 'locality', 'common-api-message'])
  const { showConfirmDialog } = useDialogCtx()
  const { customer } = useCustomerCtx()
  const { data } = useGetLocalitiesInLocalityGroups(customer.id, localityGroupId)
  const { mutateAsync: deleteLocality } = useDeleteLocality(customer.id, localityGroupId)

  const deleteLocalityAction = (id: number) => {
    showConfirmDialog(
      t('delete-confirm-locality-title', { ns: 'locality-group' }),
      t('delete-confirm-locality-description', { ns: 'locality-group' }),
      { acceptText: t('yes', { ns: 'common' }), cancelText: t('no', { ns: 'common' }) },
      async pop => {
        await deleteLocality(id, {
          onSuccess: () => {
            toast.success(t('successfullyRemoved', { ns: 'common-api-message' }))
            invalidateLocalityGroupsQueries.getLocalities(customer.id, localityGroupId)
            invalidateLocalityGroupsQueries.invalidateGetLocalityGroups(customer.id)
            pop()
          },
        })
      },
    )
  }

  const localityGroupsColumn: GridColDef[] = [
    {
      field: 'name',
      headerName: t('name', { ns: 'common' }),
      flex: 2,
      renderCell: params => params.row.name,
    },
    {
      field: 'actions',
      headerName: '',
      maxWidth: 50,
      renderCell: params => {
        return (
          <Box className="cursor-pointer">
            <Delete color="primary" onClick={() => deleteLocalityAction(params?.id as number)} />
          </Box>
        )
      },
    },
  ]

  return (
    <Box className="scrollbar" sx={{ maxHeight: '250px', overflowY: 'auto' }}>
      <CustomStyledTable
        id={'locality-locality-groups'}
        columns={localityGroupsColumn}
        data={data || []}
        getRowId={row => row.id}
        getRowHeight={() => 'auto'}
        headerHeight={0}
      />
    </Box>
  )
}

export default LocalitiesInLocalityGroups
